
import MescrollVue from 'mescroll.js/mescroll.vue'
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VBar from 'vux/src/components/v-chart/v-bar.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'
import Picker from 'vux/src/components/picker/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {querydevicelog, queryHistoryWSD, queryRadarStatistic} from '../../api/device'

export default {
name: 'historyList',
components: {
VChart,
VTooltip,
VBar,
VScale,
Picker,
MescrollVue 
},
directives: {
TransferDom
},
data () {
return {
selectNav: 'alarm',
selectDateArr: [],
selectDate: [],
selectDateType: 'month',
selectDateShow: false,
deviceObj: '',


alarmData: [],
mescrollUp: { // 上拉加载的配置.
callback: this.upCallback,
isBoth: true,
dataList: [] 
},
iconType: [
{type: 'dooropen', url: '../../../static/NB/second_history_opendoor.png'},
{type: 'doorclose', url: '../../../static/NB/second_history_closedoor.png'},
{type: 'door-open', url: '../../../static/NB/second_history_opendoor.png'},
{type: 'door-close', url: '../../../static/NB/second_history_closedoor.png'},
{type: 'sos', url: '../../../static/NB/second_history_SOS.png'},
{type: 'c-at', url: '../../../static/NB/second_history_dismantle.png'},
{type: 'sys_isactivity', url: '../../../static/NB/second_history_other.png'},
{type: 'lockrequsetopendoor', url: '../../../static/NB/doorbell.png'},
{type: 'sendopenlock', url: '../../../static/NB/remotelock.png'},
{type: 'water', url: '../../../static/NB/water.png'},
{type: 'acoff', url: '../../../static/NB/ac_off.png'},
{type: 'acon', url: '../../../static/NB/ac_on.png'},
{type: 'achighttemp', url: '../../../static/NB/highttemp.png'},
{type: 'lockopendoor', url: '../../../static/NB/second_history_opendoor.png'}, // 401开门
{type: 'lockclosedoor', url: '../../../static/NB/second_history_closedoor.png'}, // 401关门
{type: 'wifilock_open', url: '../../../static/NB/lock_on.png'}, // 401开锁
{type: 'aclowtemp', url: '../../../static/NB/diwen.png'}, // 低温,
{type: 'achightemp', url: '../../../static/NB/gaowen.png'}, // 高温,
{type: 'aclowhumidity', url: '../../../static/NB/dishi.png'}, // 低湿
{type: 'achighhumidity', url: '../../../static/NB/gaoshi.png'}, // 高湿
{type: 'wifilock_open', url: '../../../static/NB/lock_on.png'},         {type: 'wifilock_close', url: '../../../static/NB/lock_off.png'},         {type: '', url: '../../../static/NB/second_history_other.png'}
],


wsdArr: [],

radarChartKey: 0,
radarStatisticArr: [],
radarStatisticObj: {
existDuration: '',
offlineDuration: ''
}
}
},
created () {
this.getStartData()
},
methods: {
getStartData () {
this.deviceObj = this.$store.getters.get_child_obj
this.radarStatisticArr = []
let now = new Date()
let nowYear = now.getFullYear()
let nowMonth = now.getMonth() + 1
let years = []
let createOn = this.deviceObj.createon ? this.deviceObj.createon : '0000-00-00 00:00:00'
let initYear = createOn.split('-')[0] === '0000' ? 1970 : parseInt(createOn.split('-')[0])
for (let i = initYear; i <= nowYear; i++) {
years.push({ name: i + '年', value: i + '' })
}
this.selectDateArr = [years, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]]
this.selectDate = [nowYear + '', nowMonth + '']
},

/* UI */

getUrl (item) {
let iconType = this.iconType.find(r => r.type === item.alarm_type)
return iconType ? iconType.url : 'static/NB/second_history_other.png'
},
getAlarmType (atype) {
return this.common.getAlarmType(atype)
},
getSelectDateShow () {
if (this.selectDateType === 'month') {
return this.selectDate[0] + '年' + this.selectDate[1] + '月'
} else if (this.selectDateType === 'day') {
let dates = this.selectDate.split('-')
return dates[0] + '年' + dates[1] + '月' + dates[2] + '日'
}
},
getTempDesc (alarm) {
let temperature = alarm.config.find(r => r.m === 'temperature') ? alarm.config.find(r => r.m === 'temperature').v : '--'
let temperatureHigh = alarm.config.find(r => r.m === 'temperature-high') ? alarm.config.find(r => r.m === 'temperature-high').v : '--'
let temperatureLow = alarm.config.find(r => r.m === 'temperature-low') ? alarm.config.find(r => r.m === 'temperature-low').v : '--'
return '温度：' + temperature + '℃' + '（' + temperatureLow + '~' + temperatureHigh + '℃）'
},
getHumDesc (alarm) {
let humidity = alarm.config.find(r => r.m === 'humidity') ? alarm.config.find(r => r.m === 'humidity').v : '--'
let humidityHigh = alarm.config.find(r => r.m === 'humidity-high') ? alarm.config.find(r => r.m === 'humidity-high').v : '--'
let humidityLow = alarm.config.find(r => r.m === 'humidity-low') ? alarm.config.find(r => r.m === 'humidity-low').v : '--'
return '湿度：' + humidity + '%' + '（' + humidityLow + '~' + humidityHigh + '%）'
},
getProbeDesc (alarm, index) {
let title = ''
let temperature = ''
let humidity = ''
if (index === 1) {
title = '探头1：'
temperature = alarm.config.find(r => r.m === 'temperature1') ? alarm.config.find(r => r.m === 'temperature1').v : '--'
humidity = alarm.config.find(r => r.m === 'humidity1') ? alarm.config.find(r => r.m === 'humidity1').v : '--'
} else if (index === 2) {
title = '探头2：'
temperature = alarm.config.find(r => r.m === 'temperature2') ? alarm.config.find(r => r.m === 'temperature2').v : '--'
humidity = alarm.config.find(r => r.m === 'humidity2') ? alarm.config.find(r => r.m === 'humidity2').v : '--'
}
return title + temperature + ' ℃' + ' / ' + humidity + ' %'
},
getStartEnd () {
if (this.selectDateType === 'month') {
let start = ''
let end = ''
let now = new Date()
let year = now.getFullYear() + ''
let month = now.getMonth() + 1 + ''
let day = now.getDate() + ''
let endMonth = this.selectDate[1].length === 1 ? '0' + this.selectDate[1] : this.selectDate[1]
let endDay = this.getDay(this.selectDate[0], this.selectDate[1])
if (this.selectDate[0] === year && this.selectDate[1] === month) {
let today = day.length === 1 ? '0' + day : day
start = this.selectDate[0] + '-' + endMonth + '-01'
end = this.common.GetDateStr(1, this.selectDate[0] + '-' + endMonth + '-' + today)
} else {
start = this.selectDate[0] + '-' + endMonth + '-01'
end = this.common.GetDateStr(1, this.selectDate[0] + '-' + endMonth + '-' + endDay)
}
return {start: start, end: end}
} else if (this.selectDateType === 'day') {
return {start: this.selectDate + ' 00:00:00', end: this.selectDate + ' 23:59:59'}
}
},
getDay (year, month) {
let day31 = ['1', '3', '5', '7', '8', '10', '12']
let day30 = ['4', '6', '9', '11']
let day = ''
if (day31.indexOf(month) > -1) {
day = '31'
} else if (day30.indexOf(month) > -1) {
day = '30'
} else {

if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
day = '29'
} else {
day = '28'
}
}
return day
},

/* 按钮事件 */
navClick (type) {
if (this.selectNav !== type) {
if (type === 'alarm') {
setTimeout(() => {
let page = {num: 1, size: 10}
this.upCallback(page)
}, 100)
} else if (type === 'tempHum') {
this.getDeviceHistoryWSD()
} else if (type === 'radarStatistic') {
this.selectDate = new Date().format('yyyy-MM-dd')
this.selectDateType = 'day'
this.getDeviceRadarStatistic()
}
this.selectNav = type
}
},
openDate () {
this.selectDateShow = true
},
submitDate () {
this.selectDateShow = false
if (this.selectNav === 'alarm') {
setTimeout(() => {
let page = {num: 1, size: 10}
this.upCallback(page)
}, 100)
} else if (this.selectNav === 'tempHum') {
this.getDeviceHistoryWSD()
} else if (this.selectNav === 'radarStatistic') {
this.getDeviceRadarStatistic()
}
},
change (value) {
console.log('new Value', value)
},

mescrollInit (mescroll) {
this.mescroll = mescroll 
},
upCallback (page, mescroll) {

let vm = this
let startEnd = vm.getStartEnd()
let data = {
cnt: parseInt(page.size),
page: parseInt(page.num),
dids: [this.deviceObj.id],
start: startEnd.start,
end: startEnd.end
}
querydevicelog(data).then(res => {
if (res.code === 200) {
if (res.data) {
let data = res.data
for (let i = 0; i < data.length; i++) {
if (data[i].config !== '' && typeof data[i].config === 'string') {
let config = JSON.parse(data[i].config)
while (typeof config === 'string') {
config = JSON.parse(config)
}
data[i].config = config
}
}
if (page.num === 1) {
this.alarmData = data
} else {
this.alarmData = this.alarmData.concat(data)
}
}
} else {
}
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess(this.alarmData.length)
}, 100)
})
}).catch(() => {
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess(0)
}, 100)
})
})
},
getDeviceHistoryWSD () {
let vm = this
let startEnd = vm.getStartEnd()
let body = {
did: this.deviceObj.id,
start: startEnd.start,
end: startEnd.end
}
queryHistoryWSD(body).then(res => {
if (res.code === 200) {
let data = res.data
if (data) {
let wsdArr = []
data.forEach((item) => {
if (!wsdArr.find(r => r.createdAt === item.createdAt)) {
wsdArr.push(item)
}
})
vm.wsdArr = wsdArr
}
} else {}
})
},
getDeviceRadarStatistic () {
let vm = this
this.radarStatisticArr = []
this.radarStatisticObj.existDuration = 0
this.radarStatisticObj.offlineDuration = 0
let startEnd = vm.getStartEnd()
let body = {
dids: [this.deviceObj.id],
start: startEnd.start,
end: startEnd.end
}
queryRadarStatistic(body).then(res => {
if (res.code === 200) {
let data = res.data.find(r => r.did === this.deviceObj.id)
if (data) {
let duration = data.duration !== '' ? JSON.parse(data.duration) : ''
let durationOffline = data.durationOffline !== '' ? JSON.parse(data.durationOffline) : ''
Object.keys(duration).forEach(function (key) {
let time = key + ':00'
let value = duration !== '' ? Math.round(duration[key] / 60) : 0
let offlineValue = durationOffline !== '' ? Math.round(durationOffline[key] / 60) : 0
vm.radarStatisticArr.push({name: '有人时长(min)', time: time, value: value})
vm.radarStatisticArr.push({name: '无人时长(min)', time: time, value: (value + offlineValue) < 60 ? 60 - value - offlineValue : 0})
vm.radarStatisticArr.push({name: '离线时长(min)', time: time, value: offlineValue})
vm.radarStatisticObj.existDuration += duration !== '' ? duration[key] : 0
vm.radarStatisticObj.offlineDuration += durationOffline !== '' ? durationOffline[key] : 0
})
}

this.$refs.radarChart.rerender()
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/historyList.vue